import { createTracker } from 'usage-tracker';
import events from '../../events.yaml';
export const usageTracker = createTracker({
  events,
  properties: {
    pageType: 'knowledge article',
    namespace: 'knowledge article',
    screen: 'knowledge article editor'
  }
});